import { render, staticRenderFns } from "./ContratoPF.vue?vue&type=template&id=73fdcd40"
import script from "./ContratoPF.vue?vue&type=script&lang=js"
export * from "./ContratoPF.vue?vue&type=script&lang=js"
import style0 from "./ContratoPF.vue?vue&type=style&index=0&id=73fdcd40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports